import {ActionTree} from "vuex";
import {PriorityRuleItem, PriorityRulesState} from "@/store/rules/priority_rules/types";
import {RootState} from "@/store/types";
import axios from "axios";

export const actions: ActionTree<PriorityRulesState, RootState> = {
  getPriorityRules: ({commit, dispatch}, data:any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/${data.transport}/set_priority`, params: data.filter})
        .then(resp => {
          commit('setPriorityRules', resp.data?.priority_rules);
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  getPriorityRuleItem: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({url: `/acapi/${data.transport}/set_priority/${data.id}`})
        .then(resp => {
          let priorityRuleItem = <PriorityRuleItem>resp.data
          priorityRuleItem.id = data.id;
          commit('setPriorityRuleItem', priorityRuleItem);
          resolve(priorityRuleItem)
        })
        .catch(err => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  savePriorityRule: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: data.item.id ? 'put' : 'post',
        url: `/acapi/${data.transport}/set_priority/${data.item.id ?? ''}`,
        data: data.item
      })
        .then((resp:any) => {
          console.log(resp.data);
          dispatch('getPriorityRules', data);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
  deletePriorityRule: ({commit, dispatch}, data: any) => {
    commit('setLoading', true);
    return new Promise((resolve, reject) => {
      axios({
        method: 'delete',
        url: `/acapi/${data.transport}/set_priority/${data.item.id}`
      })
        .then((resp:any) => {
          dispatch('getPriorityRules', data);
          resolve(resp)
        })
        .catch((err:any) => {
          reject(err)
        })
        .finally(() => commit('setLoading', false))
    })
  },
}